import { gql } from '@apollo/client';
import showToaster from '../../helpers/showToaster';

const mutation = gql`
  mutation deleteThreadItem ($threadItemId:Int!) {
      deleteThreadItem (threadItemId:$threadItemId) {
        status
        errorMessage
      }
    }
  `;


export function deleteThreadItem(threadItemId) {
    return async (dispatch, getState, { client }) => {
    try {
       
        const { data } = await client.mutate({
          mutation,
          variables: { threadItemId },
        });
  
        if (data.deleteThreadItem.status == 200) {
            showToaster({ messageId: 'deleteUser', toasterType: 'success' })
            return data.deleteThreadItem
        } else {
          showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.deleteUser?.errorMessage })
          return data.deleteThreadItem
        }
      } catch (error) {
          return { status: 404, errorMessage: error }
      }
    }
}
